export default __webpack_public_path__ + "static/media/ic_loading.43b49ff9.gif";